var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_vm._t("default"),_c('div',{staticStyle:{"width":"100%","height":"100%"},on:{"click":_vm.closeEverything}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }